import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import moment from 'moment';
import { WorkTimeState } from '@/types/Component';

type TimeState = {
    startWorktime: Date, // 開始時間（時間で入力の場合null）
    endWorktime: Date, // 終了時間（時間で入力の場合null）
    restTime: number, // 休憩時間（時間で入力の場合null）（分で入力）
    workTime: number, // 作業時間
}

@Component({
    components: { Modal }
})
export default class SelectTime extends Vue {
    // このコンポーネントでは、モーダルを開き直した際にコンポーネントの状態を維持することを仕様とする。

    @Prop()
    private value!: boolean

    @Prop({
        required: true
    })
    private workDate?: string

    @Prop({
        required: false
    })
    private targetState?: WorkTimeState

    @Emit('input')
    private input(value: boolean) {
        value
    }

    @Emit('selectedTime')
    private selectedTime() {
        return {
            startWorktime: moment(this.state.startWorktime).format('HH:mm'),
            endWorktime: moment(this.state.endWorktime).format('HH:mm'),
            restTime: this.state.restTime,
            workTime: this.state.workTime,
        }
    }

    private state: TimeState = {
        startWorktime: new Date(),
        endWorktime: new Date(),
        restTime: 0,
        workTime: 0,
    }

    private hours = [
        {value: 0, display: '0時'},
        {value: 1, display: '1時'},
        {value: 2, display: '2時'},
        {value: 3, display: '3時'},
        {value: 4, display: '4時'},
        {value: 5, display: '5時'},
        {value: 6, display: '6時'},
        {value: 7, display: '7時'},
        {value: 8, display: '8時'},
        {value: 9, display: '9時'},
        {value: 10, display: '10時'},
        {value: 11, display: '11時'},
        {value: 12, display: '12時'},
        {value: 13, display: '13時'},
        {value: 14, display: '14時'},
        {value: 15, display: '15時'},
        {value: 16, display: '16時'},
        {value: 17, display: '17時'},
        {value: 18, display: '18時'},
        {value: 19, display: '19時'},
        {value: 20, display: '20時'},
        {value: 21, display: '21時'},
        {value: 22, display: '22時'},
        {value: 23, display: '23時'},
    ]

    private minutes = [
        {value: 0, display: '0分'},
        {value: 5, display: '5分'},
        {value: 10, display: '10分'},
        {value: 15, display: '15分'},
        {value: 20, display: '20分'},
        {value: 25, display: '25分'},
        {value: 30, display: '30分'},
        {value: 35, display: '35分'},
        {value: 40, display: '40分'},
        {value: 45, display: '45分'},
        {value: 50, display: '50分'},
        {value: 55, display: '55分'},
    ]

    private restHours = [
        {value: 0, display: '0時'},
        {value: 60, display: '1時'},
        {value: 120, display: '2時'},
        {value: 180, display: '3時'},
        {value: 240, display: '4時'},
        {value: 300, display: '5時'},
        {value: 360, display: '6時'},
        {value: 420, display: '7時'},
        {value: 480, display: '8時'},
        {value: 540, display: '9時'},
        {value: 600, display: '10時'},
        {value: 660, display: '11時'},
        {value: 720, display: '12時'},
        {value: 780, display: '13時'},
        {value: 840, display: '14時'},
        {value: 900, display: '15時'},
        {value: 960, display: '16時'},
        {value: 1020, display: '17時'},
        {value: 1080, display: '18時'},
        {value: 1140, display: '19時'},
        {value: 1200, display: '20時'},
        {value: 1260, display: '21時'},
        {value: 1320, display: '22時'},
        {value: 1380, display: '23時'},
    ]

    private startHour = 12;
    private startMinute = 0;
    private endHour = 12;
    private endMinute = 0;
    private restHour = 0;
    private restMinute = 0;

    private totalTimeStyle = ''

    private mounted() {
        this.init()
    }

    private init() {
        this.startHour = 12
        this.startMinute = 0
        this.endHour = 12
        this.endMinute = 0
        this.restHour = 0
        this.restMinute = 0

        const startDate = moment(this.workDate)
        startDate.set({hours: this.startHour, minutes: this.startMinute, seconds: 0})
        const endDate = moment(this.workDate)
        endDate.set({hours: this.endHour, minutes: this.endMinute, seconds: 0})

        this.state = {
            startWorktime: startDate.toDate(),
            endWorktime: endDate.toDate(),
            restTime: 0,
            workTime: 0,
        }
    }

    @Watch('value')
    private openModal() {
        if(this.targetState?.startWorktime) {
            const startWorktimeStr = this.targetState.startWorktime.split(':')
            this.startHour = Number(startWorktimeStr[0])
            this.startMinute = Number(startWorktimeStr[1])
        } else {
            this.startHour = 12
            this.startMinute = 0
        }
        if(this.targetState?.endWorktime) {
            const endWorktimeStr = this.targetState.endWorktime.split(':')
            this.endHour = Number(endWorktimeStr[0])
            this.endMinute = Number(endWorktimeStr[1])
        } else {
            this.endHour = 12
            this.endMinute = 0
        }
        if(this.targetState?.restTime) {
            this.restHour = Math.floor(this.targetState.restTime / 60) * 60
            this.restMinute = this.targetState.restTime % 60
        } else {
            this.restHour = 0
            this.restMinute = 0
        }
        this.updateState()
    }

    private update() {
        const newStartDate = moment(this.workDate)
        newStartDate.set({hours: this.startHour, minutes: this.startMinute, seconds: 0})
        const newEndDate = moment(this.workDate)
        newEndDate.set({hours: this.endHour, minutes: this.endMinute, seconds: 0})
        if(newEndDate.isSameOrBefore(newStartDate)){
            newEndDate.add(1, 'days')
        }
        this.state = {
            ...this.state,
            startWorktime: newStartDate.toDate(),
            endWorktime: newEndDate.toDate(),
        }
    }

    private displayDate(date: string) {
        return moment(date).format('YYYY年M月D日')
    }

    private displayTotalTime() {
        return Math.floor(this.state.workTime / 60) + '時間' + this.state.workTime % 60 + '分'
    }

    private updateState() {
        const newStartDate = moment(this.workDate)
        newStartDate.set({hours: this.startHour, minutes: this.startMinute, seconds: 0})
        const newEndDate = moment(this.workDate)
        newEndDate.set({hours: this.endHour, minutes: this.endMinute, seconds: 0})
        if(newEndDate.isBefore(newStartDate)){
            newEndDate.add(1, 'days')
        }
        const newRestTime = this.restHour + this.restMinute
        const newTotalTime = (newEndDate.diff(newStartDate) / 60000) >= newRestTime ? (newEndDate.diff(newStartDate) / 60000) - newRestTime : 0
        this.totalTimeStyle = (newEndDate.diff(newStartDate) / 60000) >= newRestTime ? '' : 'color: red'
        this.state = {
            startWorktime: newStartDate.toDate(),
            endWorktime: newEndDate.toDate(),
            restTime: newRestTime,
            workTime: newTotalTime,
        }
    }

    get isModalVisible(): boolean {
        return this.value;
    }

    set isModalVisible(value: boolean) {
        this.input(value);
    }
}
